import {call, put, takeLatest} from "redux-saga/effects";
import {avatarService} from "./avatar.service";
import {ADD_AVATAR, DELETE_AVATAR} from "./avatar.types";
import {httpRequestsOnErrorsActions} from "../http_requests_on_errors";
import {httpRequestsOnLoadActions} from "../http_requests_on_load";
import {httpRequestsOnSuccessActions} from "../http_requests_on_success";
import {GET_MY_PROFILE} from "../auth/auth.types";

function* addAvatar({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    if (!payload?.noLoad) {
        yield put(httpRequestsOnLoadActions.appendLoading(type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(avatarService.addAvatarService, payload?.id, payload?.body);
        yield put({
            type: GET_MY_PROFILE,
            payload: {type: payload?.type},
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

function* deleteAvatar({payload, type}) {
    yield put(httpRequestsOnErrorsActions.removeError(type));
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(type));
    try {
        yield call(avatarService.deleteAvatarService, payload.id);
        yield put({
            type: GET_MY_PROFILE,
            payload: {type: payload?.type},
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(type));
        yield put(httpRequestsOnErrorsActions.removeError(type));
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(type));
        yield put(
            httpRequestsOnErrorsActions.appendError(type, err?.data?.message),
        );
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

export const watchAvatar = function* watchAvatar() {
    yield takeLatest(ADD_AVATAR, addAvatar);
    yield takeLatest(DELETE_AVATAR, deleteAvatar);
};
